/**
 * Application configuration
 *
 * iter254e (2026-10-04) — Hosted assets are now served from `/public` so the
 * app is independent from the marketing site `www.ilvincente.net`. If the
 * marketing site gets restyled or an upload URL changes, the mobile apps
 * and PWA keep rendering correctly. To swap an image, drop the new file in
 * `/app/frontend/public/bookmakers/` or `/app/frontend/public/brand/` and
 * deploy — no need to touch WordPress uploads.
 */

export const BACKEND_URL = '';
export const API = '/api';

export const BRAND = {
  name: "RVINCENTE",
  tagline: "",
  logo: "/brand/rvincente-logo.png"
};

export const COMPANY = {
  name: "Global Leader Srl",
  piva: "IT09922070967",
  address: "Via Italia n. 8, 20847 Albiate (MB)",
  website: "www.ilvincente.net",
  email: "info@rvincente.it"
};

export const BOOKMAKERS = [
  {
    id: 'admiral',
    name: 'Admiral Bet',
    bonus: 'FINO A 7.000€',
    description: 'DI BONUS BENVENUTO',
    logo: '/bookmakers/admiral.png',
    url: 'https://www.admiralbet.it/gmg/refer/69666f616885620001c9fe61',
    color: '#1a237e'
  },
  {
    id: 'pokerstars',
    name: 'PokerStars',
    bonus: 'FINO A 100€',
    description: 'DI BONUS BENVENUTO',
    logo: '/bookmakers/pokerstars.png',
    url: 'https://partner-pokerstars.sisal.it/apigw/api/v1/campaign/host/partner-pokerstars.sisal.it/track?data=RFQ5U3BvcnR8QzAwMDAwNDUxfDQxM3wxNTB8&checksum',
    color: '#c62828'
  },
  {
    id: 'betsson',
    name: 'Betsson',
    bonus: 'FINO A 1.100€',
    description: 'DI BONUS BENVENUTO',
    logo: '/bookmakers/betsson.png',
    url: 'https://record.betsson.it/_7vw_VECbqUtEtDG9aSt81mNd7ZgqdRLk/1/',
    color: '#ff6f00'
  },
  {
    id: 'starvegas',
    name: 'StarVegas',
    bonus: 'FINO A 5.000€',
    description: 'DI BONUS BENVENUTO',
    logo: '/bookmakers/starvegas.png',
    url: 'https://www.starvegas.it/gmg/refer/696654efed098e000108e907',
    color: '#6a1b9a'
  },
  {
    id: 'planetwin',
    name: 'PlanetWin365',
    bonus: 'FINO A 2.050€',
    description: 'DI BONUS BENVENUTO',
    logo: '/bookmakers/planetwin.jpg',
    url: 'https://ads.planetwin365affiliate.com/redirect.aspx?pid=7137&bid=1667',
    color: '#00695c'
  },
  {
    id: 'sportbet',
    name: 'Sportbet',
    bonus: 'FINO A 200€',
    description: 'DI BONUS BENVENUTO',
    logo: '/bookmakers/sportbet.webp',
    url: 'https://www.sportbet.it/signup?codAffiliato=VSILVINCENTE&affiliato=VSILVINCENTE',
    color: '#0d47a1'
  },
  {
    id: 'lottomatica',
    name: 'Lottomatica',
    bonus: 'FINO A 2.050€',
    description: 'DI BONUS BENVENUTO',
    logo: '/bookmakers/lottomatica.jpg',
    url: 'https://media.lottomaticapartners.it/redirect.aspx?pid=13372&bid=1508',
    color: '#d32f2f'
  },
  {
    id: 'sisal',
    name: 'Sisal',
    bonus: 'FINO A 6.905€',
    description: 'DI BONUS BENVENUTO',
    logo: '/bookmakers/sisal.jpg',
    url: 'https://ads.sisal.it/promoRedirect?key=ej0xMzUyNDE2MyZsPTEzNjQ0NTE1JnA9Mjg2OTM%3D&var1=side',
    color: '#00838f'
  },
  {
    id: 'goldbet',
    name: 'Goldbet',
    bonus: 'FINO A 2.050€',
    description: 'DI BONUS BENVENUTO',
    logo: '/bookmakers/goldbet.jpg',
    url: 'https://media.goldbetpartners.it/redirect.aspx?pid=13370&bid=1494',
    color: '#f9a825'
  },
  {
    id: 'snai',
    name: 'SNAI',
    bonus: 'FINO A 1.500€',
    description: 'DI BONUS BENVENUTO',
    logo: '/bookmakers/snai.png',
    url: 'https://informatoriads.snai.it/redirect.aspx?pid=31166&bid=1953',
    color: '#1565c0'
  }
];
